import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import copy from 'copy-to-clipboard'

import Button from '@material-ui/core/Button'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'
import Tooltip from '@material-ui/core/Tooltip'
import { withStyles } from '@material-ui/core/styles'
import { CheckSystem } from '../utils/globalFun'
import openApp from '../utils/openApp'

import PhoneMask from '../componets/PhoneMask'
import HeaderLogo from '../componets/HeaderLogo'
import './ChatterChannelPage.css'
import { ReactComponent as Logo } from '../res/image/logo.svg'
import { setTimeout } from 'timers'
import { Trans, useTranslation } from 'react-i18next'

declare var document: any
declare var window: any

interface ComponentProps {
  setGlobalToken: Function
}

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#000000bf',
    boxShadow: theme.shadows[1],
    fontSize: 16,
  },
}))(Tooltip)

const ChatterChannelPage: React.FC<ComponentProps> = (props) => {
  const { setGlobalToken } = props
  const { t } = useTranslation()

  const [scheme, setScheme] = useState<string>('')
  const [iframeKey, setIframeKey] = useState<number>(0)
  const [entName, setEntName] = useState('')
  const [username, setUsername] = useState('')
  const [orgCode, setOrgCode] = useState('')
  const [inviteCode, setInviteCode] = useState('')
  const [tipOpen, setTipOpen] = useState<boolean>(false)

  const resetIframe = () => {
    let schemeUrl = scheme
    const feloScheme = `felo://join.felo.me/`
    if (schemeUrl.indexOf(feloScheme) === -1) {
      schemeUrl = feloScheme
    }
    console.log('schemeUrl:', schemeUrl)
    openApp.open(
      schemeUrl,
      (code) => {
        switch (code) {
          case 'ios':
            break
          case 'android':
            break
        }
      },
      () => {
        // setIframeKey(iframeKey + 1)
        // iosOpenScheme(scheme ? scheme : "")
        console.log('Failed to open Felo App')
      },
      2000
    )
  }

  const iosOpenScheme = (url: string) => {
    if (CheckSystem.iOS()) {
      setTimeout(() => {
        window.location.href = scheme ? scheme : url
      }, 10)
    }
  }

  const systemName = (): string => {
    if (CheckSystem.iOS()) {
      return 'iOS'
    }
    if (CheckSystem.Android()) {
      return 'Android'
    }
    if (CheckSystem.MAC()) {
      return 'macOS'
    }
    return 'Windows'
  }

  const handleTooltipOpen = () => {
    setTipOpen(!tipOpen)
  }

  const handlerTopEnter = () => {
    setTipOpen(true)
  }

  const handlerTopLeave = () => {
    setTipOpen(false)
  }
  function getobj(path: string) {
    var obj: any = {} //接收最终返回的内容
    var arr
    var str = path.split('?')[1]
    if (str != undefined) {
      arr = str.split('&') //若参数需要用&分开，说明有多个参数，则将字符串用&分割开为数组，一次性给arr
      let arr1 //arr1用于接收每个元素里面的用"="分割开的新元素
      for (var i = 0; i < arr.length; i++) {
        //for循环，将每个参数的参数名和参数值放入obj
        arr1 = arr[i].split('=') //重新赋值
        obj[arr1[0]] = arr1[1] //给对象obj添加新的属性及属性值
      }
      return obj
    }
  }
  const getLoginUrl = (index: number) => {
    const locationOrigin = window.location.origin
    let urlOrigin = 'https://account.felo.me'
    if (locationOrigin.indexOf('api.sandbox.felo.me') !== -1) {
      urlOrigin = locationOrigin
    }
    const info = getobj(window.location.href)
    if (info && info.recommend) {
      if (index === 1) {
        return `${urlOrigin}/signin?inviteCode=${inviteCode}&orgCode=${orgCode}&recommend=${info.recommend}&register=ture`
      }
      return `${urlOrigin}/signin?inviteCode=${inviteCode}&orgCode=${orgCode}&recommend=${info.recommend}`
    }
    if (index === 1) {
      return `${urlOrigin}/signin?inviteCode=${inviteCode}&orgCode=${orgCode}&register=ture`
    }
    return `${urlOrigin}/signin?inviteCode=${inviteCode}&orgCode=${orgCode}`
  }

  const isMobile = () => {
    return /Mobi|Android|iPhone/i.test(navigator.userAgent)
  }

  useEffect(() => {
    document.title = t('org.invite.title')
    let entName = document.getElementById('ent_name').getAttribute('content')
    let username = document.getElementById('username').getAttribute('content')
    let teamCode = document.getElementById('team_code').getAttribute('content')
    let inviteCode = document
      .getElementById('invite_code')
      .getAttribute('content')
    setEntName(entName || '')
    setUsername(username || '')
    setInviteCode(inviteCode || '')
    setOrgCode(teamCode)
    let url = document.location.href
    let urlOrigin = document.location.origin
    const schemeJoin = 'join.felo.me'
    if (urlOrigin.indexOf(schemeJoin) === -1) {
      url = url.replace(
        urlOrigin,
        `${document.location.protocol}//${schemeJoin}`
      )
    }
    url = url.replace('http://', 'felo://')
    url = url.replace('https://', 'felo://')
    if (isMobile()) {
      url += `?inviteCode=${inviteCode}&orgCode=${teamCode}`

      setScheme(url)
      iosOpenScheme(url)
    }
  }, [])

  return (
    <div className='chatter-channel-page inviting-page-container'>
      <HeaderLogo />
      <PhoneMask />

      <section className='appinfo'>
        <div className='appinfo-title'>
          {t('org.invite', { username: username, entName: entName })}
        </div>
        <div className='appinfo-teamcode'>
          <p className='desc'>{t('org.code.desc')}</p>
          <p className='teamcode'>
            <span>{t('org.code')}</span>
            {/* <LightTooltip
                            title={<Trans>org.code.description</Trans>}
                            open={tipOpen}
                            disableTouchListener
                            disableFocusListener
                            disableHoverListener
                        >
                            <HelpOutlineIcon onClick={handleTooltipOpen} onMouseEnter={handlerTopEnter} onMouseLeave={handlerTopLeave} />
                        </LightTooltip> */}
            <div className='invite-code-box'>
              <span>{inviteCode}</span>
              <Button
                href='#'
                className='copy-btn'
                color='primary'
                onClick={() => copy(inviteCode)}
              >
                {t('org.code.copy')}
              </Button>
            </div>
          </p>
        </div>
      </section>

      <div className='content-btn-wrap'>
        <Button
          className='download-btn sign-in'
          variant='outlined'
          color='primary'
          href={getLoginUrl(0)}
          target='_blank'
        >
          {t('app.login')}
        </Button>
        <Button
          className='download-btn sign-up'
          variant='outlined'
          color='primary'
          href={getLoginUrl(1)}
          target='_blank'
        >
          {t('app.register')}
        </Button>
        {/* <Button className="download-btn" variant="outlined" color="primary" href="https://www.felo.me/download" target="_blank">
                    {t('app.download', { system: systemName() })}
                </Button> */}
      </div>

      <section className='download'>
        <div className='download-not-install'>{t('app.install')}</div>

        <div className='download-installed'>
          <span> {t('app.installed')}</span>
          <Button href='#' color='primary' onClick={resetIframe}>
            {t('app.open')}
          </Button>
        </div>
        {/* <div className="download-desc">Available on iOS, Android, macOS, and Windows.</div>
                <section className="download-platform-list">
                    <DownloadPlatformList />
                </section> */}
      </section>
      <div className='select-lang'></div>
      <iframe title='scheme' hidden src={scheme} key={iframeKey} />
    </div>
  )
}

const stateProps = (state: any) => {
  return {
    jwtToken: state.jwtToken,
  }
}

const dispatchProps = (dispatch: any) => ({
  setGlobalToken: (token: string) => {
    dispatch({
      type: 'setToken',
      value: token,
    })
  },
})

export default connect(stateProps, dispatchProps)(ChatterChannelPage)
